export const PROJECT_THUMBNAIL_PLACEHOLDER = '/assets/default-image-missing.avif';

export const RECENT_PROJECTS_LIMIT = 3;
